/**
 * Cloning object structure
 * @param obj {Object}
 */
export const structuredClonePolyfill = <T = Object>(obj: T): T => {
    if (typeof structuredClone === "function") {
        return structuredClone(obj);
    } else {
        return JSON.parse(JSON.stringify(obj));
    }
};
